/* eslint-disable @typescript-eslint/no-floating-promises */
import { useCallback } from 'react';
import { useGqlContext } from '@search/gql-client/src/gqlContext';

import type {
    TrackOfferMutation$data as TrackOfferMutationResponse, TrackOfferMutation$variables as TrackOfferMutationVariables
} from './__generated__/TrackOfferMutation.graphql';

import { TrackOfferMutation } from './TrackOfferMutation';

type IUseClickerTracker = () => {
    trackOfferView: (offerId: string) => void;
    trackPhoneView: (offerId: string, countryCode?: string, number?: string) => void;
}

export const useClickerTracker: IUseClickerTracker = () => {
    const gql = useGqlContext();

    const trackOfferView = useCallback((offerId: string) => {
        gql.client<TrackOfferMutationVariables, TrackOfferMutationResponse>(TrackOfferMutation,
            { offerId }
        );
    }, [ gql ]);

    const trackPhoneView = useCallback((offerId: string, countryCode?: string, number?: string) => {
        gql.client<TrackOfferMutationVariables, TrackOfferMutationResponse>(TrackOfferMutation,
            { offerId, countryCode, number, isPhone: true }
        );
    }, [ gql ]);

    return {
        trackOfferView,
        trackPhoneView
    };
};
